export const servicesSlugs = {
  managementConsulting: "management-consulting",
  humanCapitalDevelopment: "human-capital-development",
  techAndServices: "tech-amd-services",
  productManagement: "product-management",
  manageServices: "manage-services",
  creative: "creative",
  financialConsultancy: "financial-consultancy",
};

export const productTags = {
  edTechAndLearning: "edTechAndLearning",
  dataTechAndAnalytics: "dataTechAndAnalytics",
  salesAndDistribution: "salesAndDistribution",
  peopleTechAndHRM: "peopleTechAndHRM",
  projectManage: "projectManage",
  lifeStyle: "lifeStyle",
  others: "others",
};

export const openingSlugs = {
  seniorUiUxDesigner: "senior-ui-ux-designer",
  juniorSoftwareDeveloper: "junior-software-developer",
  socialMediaManager: "social-media-manager",
  dataAnalyst: "data-analyst",
  productManager: "product-manager",
  hrCoordinator: "hr-coordinator",
};
